import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  { icon: 'dashboard', label: 'Dashboard', path: '/portal/dashboard' },
  { icon: 'notifications', label: 'Notifications', path: '/portal/notifications' },
  { icon: 'settings', label: 'Settings', path: '/portal/settings' },
];

export default function PortalSidebar() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const close = () => setIsOpen(false);

  return (
    <>
      <div className="md:hidden fixed top-0 left-0 right-0 h-16 bg-[#f2f4f6] border-b border-[#e2e8f0] flex items-center justify-between px-4 z-40">
        <button onClick={() => setIsOpen(true)} className="p-2 text-[#00255a]">
          <span className="material-symbols-outlined">menu</span>
        </button>
        <h1 className="text-lg font-bold text-[#00255a]">Student Portal</h1>
        <div className="w-10" />
      </div>

      {isOpen && <div onClick={close} className="fixed inset-0 bg-black/40 z-40 md:hidden" />}

      <aside
        className={`fixed left-0 top-0 h-screen w-64 bg-[#f2f4f6] border-r border-[#e2e8f0] flex flex-col p-4 z-50 transform transition-transform duration-300 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } md:translate-x-0`}
      >
        <div className="px-4 py-6 mb-2 flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-[#00255a]">Student Portal</h1>
            <p className="text-[#64748b] text-sm">Global Opportunities</p>
          </div>
          <button onClick={close} className="md:hidden p-1 text-[#64748b]">
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>

        <nav className="flex-grow overflow-y-auto space-y-1 min-h-0">
          {NAV_ITEMS.map((item) => {
            const active = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                onClick={close}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg font-semibold transition-all ${
                  active ? 'bg-[#00255a] text-white' : 'text-[#44474f] hover:bg-[#e6e8ea]'
                }`}
              >
                <span className="material-symbols-outlined">{item.icon}</span>
                <span className="text-sm">{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="flex-shrink-0 space-y-4 pt-6 border-t border-[#e2e8f0] mt-4">
          <a
            href="https://wa.me/263775827371"
            className="w-full block text-center py-3 text-white rounded-xl font-bold shadow-lg hover:scale-[1.02] transition-transform text-sm"
            style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 60%, #ff7b7b 100%)' }}
          >
            Speak with Advisor
          </a>
          <div className="space-y-1">
            <Link to="/faq" onClick={close} className="flex items-center gap-3 px-4 py-2 text-[#44474f] hover:bg-[#e6e8ea] rounded-lg text-sm">
              <span className="material-symbols-outlined text-sm">help</span>
              <span>Help Center</span>
            </Link>
            <button
              onClick={() => { localStorage.removeItem('token'); window.location.href = '/login'; }}
              className="w-full flex items-center gap-3 px-4 py-2 text-[#44474f] hover:bg-[#e6e8ea] rounded-lg text-sm text-left"
            >
              <span className="material-symbols-outlined text-sm">logout</span>
              <span>Logout</span>
            </button>
          </div>
        </div>
      </aside>
    </>
  );
}